import { useState, useEffect } from "react";
import ProductCard from "../components/ProductCard";
// import AffiliateProducts from "../components/AffiliateProducts"; // COMMENTED: Affiliate member functionality disabled
import HamburgerMenu from "../components/HamburgerMenu";
import { FaSearch } from "react-icons/fa";

export default function HomeWithFilters({ 
  search, 
  setSearch, 
  selectedCategory, 
  setSelectedCategory, 
  sortBy, 
  setSortBy,
  categories
}) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/products/all`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        
        // Map API response to existing product structure
        const mappedProducts = data.map(product => ({
          id: product.id,
          title: product.title,
          price: product.price,
          image: product.image,
          affiliateLink: product.affiliateLink,
          platform: product.platform,
          rating: product.rating,
          category: product.category,
          dealEndTime: product.dealEndTime
        }));
        
        setProducts(mappedProducts);
        setLoading(false);
      } catch (err) {
        console.error("API FETCH ERROR:", err);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Filter and sort products
  const filteredProducts = products.filter((p) => {
    const matchesSearch = !search || p.title?.toLowerCase().includes(search.toLowerCase());
    const matchesCategory =
      selectedCategory === "All" ||
      p.category?.toLowerCase().trim() ===
        selectedCategory.toLowerCase().trim();
    return matchesSearch && matchesCategory;
  });

  console.log('Filter debug:', { 
    search, 
    selectedCategory, 
    sortBy, 
    totalProducts: products.length,
    filteredCount: filteredProducts.length 
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    // Always apply search relevance first, then sort
    const aSearchRelevance = search && a.title ? a.title.toLowerCase().indexOf(search.toLowerCase()) : -1;
    const bSearchRelevance = search && b.title ? b.title.toLowerCase().indexOf(search.toLowerCase()) : -1;
    
    // If searching and both have matches, prioritize search relevance
    if (search && aSearchRelevance !== -1 && bSearchRelevance !== -1) {
      if (aSearchRelevance !== bSearchRelevance) {
        return aSearchRelevance - bSearchRelevance;
      }
    }
    
    // If no search or same relevance, apply sort
    switch (sortBy) {
      case "price-low":
        return parseFloat(a.price) - parseFloat(b.price);
      case "price-high":
        return parseFloat(b.price) - parseFloat(a.price);
      case "rating":
        return (b.rating || 0) - (a.rating || 0);
      case "name-asc":
        return a.title?.localeCompare(b.title) || 0;
      case "name-desc":
        return b.title?.localeCompare(a.title) || 0;
      default:
        return 0;
    }
  });

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading products…</p>;
  }

  if (!products.length) {
    return <p style={{ textAlign: "center" }}>No products found</p>;
  }

  return (
    <div className="page-content">
      <p style={{ textAlign: "left", marginBottom: "20px" }}>welcome to Doodle cart</p>
      
      {/* COMMENTED: Affiliate Products Section disabled */}
      {/* <AffiliateProducts /> */}
      
      {/* All Products Section */}
      <div>
        <h2 style={{ 
          fontSize: "24px", 
          marginBottom: "20px", 
          color: "#333",
          borderBottom: "2px solid #3498db",
          paddingBottom: "10px"
        }}>
          🛒 All Products
        </h2>
        
        {/* Results Count */}
        <div className="results-info">
          <span>Showing {sortedProducts.length} of {products.length} products</span>
        </div>

        {/* Products Grid */}
        <div className="grid">
          {sortedProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </div>
  );
}
